// extracted by mini-css-extract-plugin
export default {"messStatistic":"index_messStatistic__oTpkb"};